import { put, takeLatest, fork, call } from "redux-saga/effects";
import { ChangePasswordData, ActionType } from "models/changePassword";
import { IResponse } from "models";
import { httpStatus } from "configs/httpStatus";
import { requestChangePassword } from "services/auth";
import { handleSuccesAction, handleErrorAction } from "./changePasswordActions";

function* changePasswordSaga({ payload }: { payload: ChangePasswordData }) {
  try {
    const response: IResponse = yield call(requestChangePassword, payload);

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnprocessableEntity) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction("Error" || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onChangePasswordWatcher() {
  yield takeLatest(ActionType.CHANGE_PASSWORD as any, changePasswordSaga);
}

export default [fork(onChangePasswordWatcher)];
